<template>
	<div class="title mb-sm">{{ data.title }} <slot name="close"></slot></div>
</template>
<script>
export default {
	name: 'TipsPreview',
	props: {
		data: Object
	}
}
</script>
<style scoped>
.title {
	font-size: 14px;
	padding: 10px 0 10px 15px;
	background-color: transparent;
	font-weight: normal;
	color: #666;
}
</style>
